export default "__VITE_ASSET__CPpMsZ7q__"